import { render, staticRenderFns } from "./userDropdown.vue?vue&type=template&id=0142581d&scoped=true"
import script from "./userDropdown.vue?vue&type=script&lang=js"
export * from "./userDropdown.vue?vue&type=script&lang=js"
import style0 from "./userDropdown.vue?vue&type=style&index=0&id=0142581d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0142581d",
  null
  
)

export default component.exports